import { render, staticRenderFns } from "./gpc.vue?vue&type=template&id=930131c8&scoped=true&"
import script from "./gpc.vue?vue&type=script&lang=js&"
export * from "./gpc.vue?vue&type=script&lang=js&"
import style0 from "./gpc.vue?vue&type=style&index=0&id=930131c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930131c8",
  null
  
)

export default component.exports